<app-blog-shell [blogId]="'design-intention'" [darkMode]="darkMode">
  <div #entryRoot class="blog-entry">
    <h1 data-translate="BLOG.DETAILS.design-intention.TITLE"></h1>
    <br>

    <h2 data-translate="BLOG.DETAILS.design-intention.TLDR.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.TLDR.BODY"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.SECTION1.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION1.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.SECTION2.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION2.P1"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.SECTION3.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION3.P1"></p>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION3.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.SECTION4.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION4.P1"></p>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION4.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.SECTION5.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION5.P1"></p>
    <p data-translate="BLOG.DETAILS.design-intention.SECTION5.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.SECTION6.HEADLINE"></h2>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.design-intention.SECTION6.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.design-intention.SECTION6.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.design-intention.SECTION6.ITEM3"></li>
      <li data-translate="BLOG.DETAILS.design-intention.SECTION6.ITEM4"></li>
      <li data-translate="BLOG.DETAILS.design-intention.SECTION6.ITEM5"></li>
    </ul>

    <br>
    <h2 data-translate="BLOG.DETAILS.design-intention.CONCLUSION.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.design-intention.CONCLUSION.P1"></p>
    <p data-translate="BLOG.DETAILS.design-intention.CONCLUSION.P2"></p>
  </div>
  <br>
</app-blog-shell>
